import { PaymentList } from '@/models/api/payment/payment'
import { startChain } from '@spa/components/pages/order/model/payment/initialization/function/chain-specification'
import { PaymentInitializationSpec } from '@spa/components/pages/order/model/payment/initialization/specification'
import {
  CreditcardStore,
  UsePreviousPaymentMethod,
} from '@spa/components/pages/order/model/payment/initialization/specification/use-previous-payment-method'
import {
  UseSpecifiedPaymentByQuery
} from '@spa/components/pages/order/model/payment/initialization/specification/use-specified-payment-by-query'
import { PurchaseService } from '@spa/services/api/purchase'

export interface PaymentInitializerDeps {
  readonly purchaseService: PurchaseService
  readonly availablePaymentList: PaymentList
  readonly creditcardStore: CreditcardStore
  readonly location: Location
}

export function setupPaymentInitializationSpec(deps: PaymentInitializerDeps): PaymentInitializationSpec {
  return startChain(
    UseSpecifiedPaymentByQuery.fromLocation(deps.location, deps.availablePaymentList)
  ).thenTry(
    UsePreviousPaymentMethod.create(deps.purchaseService, deps.availablePaymentList, deps.creditcardStore)
  )
}
